// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Stack, Typography } from '@mui/material';
// utils
import { fShortenNumber, shortNumber } from '../../../utils/formatNumber';
// components
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

// ----------------------------------------------------------------------

AppWidgetSMV.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  sell: PropTypes.number.isRequired,
  click: PropTypes.number.isRequired,
  sx: PropTypes.object,
};

export default function AppWidgetSMV({ title, subTitle, sell, click, icon, color = 'primary', sx, ...other }) {
  return (
    <Card
      sx={{
        py: 5,
        boxShadow: 0,
        textAlign: 'center',
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        ...sx,
      }}
      {...other}
    >
      <IconWrapperStyle
        sx={{
          color: (theme) => theme.palette[color].dark,
          backgroundImage: (theme) =>
            `linear-gradient(135deg, ${alpha(theme.palette[color].dark, 0)} 0%, ${alpha(
              theme.palette[color].dark,
              0.24
            )} 100%)`,
        }}
      >
        <Iconify icon={icon} width={24} height={24} />
      </IconWrapperStyle>

      <Stack direction="row" justifyContent="center" alignItems="center">
        <Typography variant="h6" sx={{ opacity: 0.72 }}>
          Nombre de vente :
        </Typography>
        <Typography variant="h6">{shortNumber(sell)}</Typography>
      </Stack>

      <Stack direction="row" justifyContent="center" alignItems="center">
        <Typography variant="body2" sx={{ opacity: 0.72 }}>
          Nombre de click :
        </Typography>
        <Typography variant="body2">{shortNumber(click)}</Typography>
      </Stack>

      <Stack direction="row" justifyContent="center" alignItems="center" paddingTop={2} spacing={1}>
        <Iconify icon="bi:copy" />
        <Typography variant="body2">Copier lien</Typography>
      </Stack>
    </Card>
  );
}
